module.exports = __webpack_public_path__ + "static/media/New.77b02b56.svg";